import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vShow as _vShow, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/print/print_logo.png'
import _imports_1 from '@/assets/img/print/qrcode.jpg'

const _withId = /*#__PURE__*/_withScopeId("data-v-5f14bc02")

_pushScopeId("data-v-5f14bc02")
const _hoisted_1 = { class: "bg-ff table-content" }
const _hoisted_2 = { class: "top-button-group" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = { class: "top-button-group flex flexSb alignC" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "常用件采购", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "既用件采购", -1)
const _hoisted_7 = { class: "flex alignC cascader" }
const _hoisted_8 = { class: "flex alignC cascader" }
const _hoisted_9 = { class: "flex alignC cascader" }
const _hoisted_10 = { class: "flex" }
const _hoisted_11 = { class: "flex top-button-group" }
const _hoisted_12 = { class: "flex alignC" }
const _hoisted_13 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8" }, "类型", -1)
const _hoisted_14 = { class: "flex alignC cascader" }
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8" }, "状态", -1)
const _hoisted_16 = { class: "flex alignC cascader" }
const _hoisted_17 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8" }, "供应商", -1)
const _hoisted_18 = { class: "flex alignC cascader" }
const _hoisted_19 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8" }, "采购员", -1)
const _hoisted_20 = { class: "flex button-group" }
const _hoisted_21 = /*#__PURE__*/_createVNode("span", { class: "c-red" }, "信息编辑", -1)
const _hoisted_22 = {
  key: 0,
  class: "button-group"
}
const _hoisted_23 = /*#__PURE__*/_createVNode("span", { class: "c-red" }, "恢复", -1)
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "button-group" }
const _hoisted_26 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "反审核", -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "审核", -1)
const _hoisted_28 = {
  key: 0,
  class: "flex button-group"
}
const _hoisted_29 = /*#__PURE__*/_createVNode("span", { class: "c-red" }, "退货", -1)
const _hoisted_30 = /*#__PURE__*/_createVNode("span", { class: "c-red" }, "打印", -1)
const _hoisted_31 = {
  id: "printBtn",
  style: {"display":"none"}
}
const _hoisted_32 = {
  key: 1,
  class: "flex button-group"
}
const _hoisted_33 = /*#__PURE__*/_createVNode("span", { class: "c-red" }, "修改", -1)
const _hoisted_34 = /*#__PURE__*/_createVNode("span", { class: "c-red" }, "作废", -1)
const _hoisted_35 = { class: "flex flexR mar-t-22" }
const _hoisted_36 = { class: "flex" }
const _hoisted_37 = { class: "dialog-footer" }
const _hoisted_38 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "保存", -1)
const _hoisted_39 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_40 = {
  border: "0",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_41 = { class: "print" }
const _hoisted_42 = { class: "date" }
const _hoisted_43 = { class: "header" }
const _hoisted_44 = /*#__PURE__*/_createVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_45 = { class: "title" }
const _hoisted_46 = { class: "body" }
const _hoisted_47 = { class: "ordersn" }
const _hoisted_48 = {
  class: "project-table",
  border: "1",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_49 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", { width: "5%" }, "序号"),
    /*#__PURE__*/_createVNode("th", { width: "10%" }, "配件名称"),
    /*#__PURE__*/_createVNode("th", { width: "10%" }, "规格"),
    /*#__PURE__*/_createVNode("th", { width: "5%" }, "编码"),
    /*#__PURE__*/_createVNode("th", { width: "10%" }, "配件分类"),
    /*#__PURE__*/_createVNode("th", { width: "10%" }, "品牌"),
    /*#__PURE__*/_createVNode("th", { width: "5%" }, "单位"),
    /*#__PURE__*/_createVNode("th", { width: "10%" }, "采购单价"),
    /*#__PURE__*/_createVNode("th", { width: "5%" }, "采购数量"),
    /*#__PURE__*/_createVNode("th", { width: "5%" }, "已退数量"),
    /*#__PURE__*/_createVNode("th", { width: "10%" }, "金额")
  ])
], -1)
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { key: 1 }
const _hoisted_52 = { key: 2 }
const _hoisted_53 = { key: 3 }
const _hoisted_54 = /*#__PURE__*/_createVNode("th", {
  colspan: "8",
  style: {"text-align":"right"}
}, "合计：", -1)
const _hoisted_55 = {
  colspan: "11",
  style: {"text-align":"left"}
}
const _hoisted_56 = {
  class: "other",
  style: {"padding-top":"30px"}
}
const _hoisted_57 = { class: "info" }
const _hoisted_58 = { class: "item" }
const _hoisted_59 = { class: "item" }
const _hoisted_60 = { class: "item" }
const _hoisted_61 = /*#__PURE__*/_createVNode("div", { class: "store" }, [
  /*#__PURE__*/_createVNode("div", { class: "name" }, " 巨狼养车 "),
  /*#__PURE__*/_createVNode("div", { class: "qrcode" }, [
    /*#__PURE__*/_createVNode("img", {
      src: _imports_1,
      alt: ""
    })
  ])
], -1)
const _hoisted_62 = { class: "footer" }
const _hoisted_63 = { class: "address" }
const _hoisted_64 = { class: "telphone" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _component_PrintForm = _resolveComponent("PrintForm")
  const _directive_print = _resolveDirective("print")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            (_ctx.roleList.common)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  class: "bg-red",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx._option('/purchase/commonParts', {type: 'commonly'})))
                }, {
                  default: _withId(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.roleList.temporary)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  class: "bg-red",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx._option('/purchase/readyUseParts', {type: 'existing'})))
                }, {
                  default: _withId(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_7, [
            _createVNode(_component_el_select, {
              class: "mar-r-8",
              style: {"width":"108px"},
              modelValue: _ctx.screenParameter.time_type,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.screenParameter.time_type = $event)),
              onChange: _ctx.selectChange,
              placeholder: "请选择",
              clearable: ""
            }, {
              default: _withId(() => [
                _createVNode(_component_el_option, {
                  label: "单据日期",
                  value: "1"
                }),
                _createVNode(_component_el_option, {
                  label: "制单时间",
                  value: "2"
                }),
                _createVNode(_component_el_option, {
                  label: "审核时间",
                  value: "3"
                })
              ]),
              _: 1
            }, 8, ["modelValue", "onChange"])
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode(_component_el_date_picker, {
              modelValue: _ctx.screen.time,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.screen.time = $event)),
              type: "daterange",
              align: "right",
              "unlink-panels": "",
              "range-separator": "-",
              "start-placeholder": "开始日期",
              "end-placeholder": "结束日期",
              shortcuts: _ctx.shortcuts,
              onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.screenChange($event, 'time')))
            }, null, 8, ["modelValue", "shortcuts"])
          ]),
          _createVNode("div", _hoisted_9, [
            _createVNode(_component_el_input, {
              modelValue: _ctx.screenParameter.search,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.screenParameter.search = $event)),
              placeholder: "单据编号/配件/实际采购单号",
              "suffix-icon": "el-icon-search",
              class: "width-211",
              clearable: "",
              onChange: _ctx.searchChange
            }, null, 8, ["modelValue", "onChange"])
          ])
        ]),
        _createVNode("div", _hoisted_10, [
          _createVNode("div", _hoisted_11, [
            _createVNode("div", _hoisted_12, [
              _hoisted_13,
              _createVNode(_component_el_select, {
                class: "mar-r-8",
                style: {"width":"108px"},
                modelValue: _ctx.screenParameter.purchase_type,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.screenParameter.purchase_type = $event)),
                onChange: _ctx.selectChange,
                placeholder: "请选择",
                clearable: ""
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_option, {
                    label: "库存配件",
                    value: "1"
                  }),
                  _createVNode(_component_el_option, {
                    label: "临时配件",
                    value: "2"
                  }),
                  _createVNode(_component_el_option, {
                    label: "采购退货",
                    value: "3"
                  }),
                  _createVNode(_component_el_option, {
                    label: "其他成本",
                    value: "4"
                  })
                ]),
                _: 1
              }, 8, ["modelValue", "onChange"])
            ]),
            _createVNode("div", _hoisted_14, [
              _hoisted_15,
              _createVNode(_component_el_select, {
                class: "mar-r-8",
                style: {"width":"108px"},
                modelValue: _ctx.screenParameter.status,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.screenParameter.status = $event)),
                onChange: _ctx.selectChange,
                placeholder: "请选择",
                clearable: ""
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_option, {
                    label: "待审核",
                    value: "1"
                  }),
                  _createVNode(_component_el_option, {
                    label: "已审核",
                    value: "2"
                  }),
                  _createVNode(_component_el_option, {
                    label: "已作废",
                    value: "3"
                  })
                ]),
                _: 1
              }, 8, ["modelValue", "onChange"])
            ]),
            _createVNode("div", _hoisted_16, [
              _hoisted_17,
              _createVNode(_component_el_select, {
                class: "mar-r-8",
                style: {"width":"108px"},
                modelValue: _ctx.screenParameter.supplier_id,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.screenParameter.supplier_id = $event)),
                onChange: _ctx.selectChange,
                placeholder: "请选择",
                clearable: "",
                filterable: ""
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.supplierList, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.supplier_id,
                      label: item.supplier_name,
                      value: item.supplier_id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "onChange"])
            ]),
            _createVNode("div", _hoisted_18, [
              _hoisted_19,
              _createVNode(_component_el_select, {
                class: "mar-r-8",
                style: {"width":"108px"},
                modelValue: _ctx.screenParameter.employee_id,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.screenParameter.employee_id = $event)),
                onChange: _ctx.selectChange,
                placeholder: "请选择",
                clearable: "",
                filterable: ""
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.adminList, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.nickname,
                      value: item.id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "onChange"])
            ])
          ])
        ])
      ]),
      _createVNode("div", null, [
        _withDirectives(_createVNode(_component_el_table, {
          data: _ctx.tableData,
          stripe: "",
          style: {"width":"100%"},
          class: "table",
          "header-cell-style": _ctx.headClass
        }, {
          default: _withId(() => [
            _createVNode(_component_el_table_column, {
              label: "单据编号",
              align: "center",
              "min-width": "164"
            }, {
              default: _withId((scope) => [
                _createVNode("div", {
                  class: "c-red purchaes_number",
                  onClick: ($event: any) => (_ctx.bindPurchaseInfo(scope.row.purchase_id))
                }, _toDisplayString(scope.row.purchaes_number), 9, ["onClick"])
              ]),
              _: 1
            }),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columnList, (item, index) => {
              return (_openBlock(), _createBlock(_component_el_table_column, {
                align: "center",
                prop: item.prop,
                label: item.label,
                "min-width": item.width,
                formatter: _ctx.getText,
                key: index
              }, null, 8, ["prop", "label", "min-width", "formatter"]))
            }), 128)),
            _createVNode(_component_el_table_column, {
              label: "操作",
              align: "center",
              "min-width": "120"
            }, {
              default: _withId((scope) => [
                _createVNode("div", _hoisted_20, [
                  _createVNode("p", {
                    class: "flex-1 mar-r-4 btn",
                    onClick: ($event: any) => (_ctx.buttonClick(6,scope.row.purchase_id,0))
                  }, [
                    _hoisted_21
                  ], 8, ["onClick"])
                ]),
                (scope.row.purchase_status==1)
                  ? (_openBlock(), _createBlock("div", _hoisted_22, [
                      _createVNode("div", null, [
                        (_ctx.roleList.recovery)
                          ? (_openBlock(), _createBlock("p", {
                              key: 0,
                              class: "btn",
                              onClick: ($event: any) => (_ctx.buttonClick(2,scope.row.purchase_id,0))
                            }, [
                              _hoisted_23
                            ], 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_24, [
                      _createVNode("div", _hoisted_25, [
                        (scope.row.is_toexamine==1&&_ctx.roleList.recheck)
                          ? (_openBlock(), _createBlock("p", {
                              key: 0,
                              class: "bg-red btn",
                              style: {"min-width":"80px"},
                              onClick: ($event: any) => (_ctx._toexamine(scope.row.purchase_id))
                            }, [
                              _hoisted_26
                            ], 8, ["onClick"]))
                          : _createCommentVNode("", true),
                        (scope.row.is_toexamine==0&&_ctx.roleList.check)
                          ? (_openBlock(), _createBlock("p", {
                              key: 1,
                              class: "bg-red btn",
                              style: {"min-width":"80px"},
                              onClick: ($event: any) => (_ctx._toexamine(scope.row.purchase_id))
                            }, [
                              _hoisted_27
                            ], 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]),
                      (scope.row.is_toexamine==1)
                        ? (_openBlock(), _createBlock("div", _hoisted_28, [
                            (scope.row.button.return&&_ctx.roleList.return)
                              ? (_openBlock(), _createBlock("p", {
                                  key: 0,
                                  class: "flex-1 mar-r-4 btn",
                                  onClick: ($event: any) => (_ctx._option('/purchase/returnGoods', {type: 'returngood', id: scope.row.purchase_id}))
                                }, [
                                  _hoisted_29
                                ], 8, ["onClick"]))
                              : _createCommentVNode("", true),
                            (_ctx.roleList.print)
                              ? (_openBlock(), _createBlock("p", {
                                  key: 1,
                                  class: "flex-1 btn",
                                  onClick: ($event: any) => (_ctx.bindPrint(scope.row))
                                }, [
                                  _hoisted_30
                                ], 8, ["onClick"]))
                              : _createCommentVNode("", true),
                            _withDirectives(_createVNode("div", _hoisted_31, null, 512), [
                              [_directive_print, _ctx.printData]
                            ])
                          ]))
                        : (_openBlock(), _createBlock("div", _hoisted_32, [
                            (_ctx.roleList.edit)
                              ? (_openBlock(), _createBlock("p", {
                                  key: 0,
                                  class: "flex-1 mar-r-4 btn",
                                  onClick: ($event: any) => (_ctx.buttonClick(3,scope.row.purchase_id,scope.row.purchase_type))
                                }, [
                                  _hoisted_33
                                ], 8, ["onClick"]))
                              : _createCommentVNode("", true),
                            (_ctx.roleList.void)
                              ? (_openBlock(), _createBlock("p", {
                                  key: 1,
                                  class: "flex-1 btn",
                                  onClick: ($event: any) => (_ctx.buttonClick(1,scope.row.purchase_id,0))
                                }, [
                                  _hoisted_34
                                ], 8, ["onClick"]))
                              : _createCommentVNode("", true)
                          ]))
                    ]))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data", "header-cell-style"]), [
          [_directive_loading, _ctx.loading]
        ]),
        _createVNode("div", _hoisted_35, [
          _createVNode(_component_el_pagination, {
            onSizeChange: _ctx.handleSizeChange,
            onCurrentChange: _ctx.handleCurrentChange,
            "current-page": _ctx.screenParameter.page,
            "page-sizes": [10, 20,50,100],
            "page-size": _ctx.screenParameter.pagesize,
            layout: "total, sizes, prev, pager, next, jumper",
            total: _ctx.total
          }, null, 8, ["onSizeChange", "onCurrentChange", "current-page", "page-size", "total"])
        ]),
        _createVNode(_component_el_dialog, {
          title: "常用件采购",
          modelValue: _ctx.dialog_show.commonly,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.dialog_show.commonly = $event)),
          center: "",
          width: 1000
        }, {
          footer: _withId(() => []),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      title: "编辑",
      modelValue: _ctx.editCarData.dialog_show,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.editCarData.dialog_show = $event)),
      center: "",
      width: 1000
    }, {
      footer: _withId(() => [
        _createVNode("span", _hoisted_37, [
          _createVNode(_component_el_button, {
            class: "bg-red",
            onClick: _ctx.saveSubmit
          }, {
            default: _withId(() => [
              _hoisted_38
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.editCarData.dialog_show = false))
          }, {
            default: _withId(() => [
              _hoisted_39
            ]),
            _: 1
          })
        ])
      ]),
      default: _withId(() => [
        _createVNode(_component_el_form, {
          ref: _ctx.editCarData.formRef,
          model: _ctx.editCarData.form,
          rules: _ctx.editCarData.rules,
          "label-width": "100px"
        }, {
          default: _withId(() => [
            _createVNode("div", _hoisted_36, [
              _createVNode(_component_el_form_item, { label: "单据日期" }, {
                default: _withId(() => [
                  _createVNode(_component_el_date_picker, {
                    class: "input-wid",
                    modelValue: _ctx.editCarData.form.purchase_date,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.editCarData.form.purchase_date = $event)),
                    placeholder: "请选择单据日期"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "采购详情",
      modelValue: _ctx.dialogFormVisible,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.dialogFormVisible = $event)),
      onClosed: _ctx.handleClose,
      center: "",
      width: 1000
    }, {
      default: _withId(() => [
        _createVNode("table", _hoisted_40, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.detailTable, (items, index) => {
            return (_openBlock(), _createBlock("tr", { key: index }, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(items, (item, idx) => {
                return (_openBlock(), _createBlock("td", { key: idx }, _toDisplayString(item), 1))
              }), 128))
            ]))
          }), 128))
        ]),
        (_ctx.isMountings)
          ? (_openBlock(), _createBlock(_component_el_table, {
              key: 0,
              data: _ctx.purchaseDetail.data,
              stripe: "",
              style: {"width":"100%"},
              class: "mar-b-10",
              "show-summary": "",
              "summary-method": (item) => _ctx.getSummaries(item, 1),
              "header-cell-style": _ctx.headClass
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.purchaseColumn, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_table_column, {
                    align: "center",
                    prop: item.prop,
                    label: item.label,
                    "min-width": item.width,
                    key: index
                  }, null, 8, ["prop", "label", "min-width"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["data", "summary-method", "header-cell-style"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "onClosed"]),
    _withDirectives(_createVNode(_component_PrintForm, { id: "print" }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_41, [
          _createVNode("div", _hoisted_42, _toDisplayString(_ctx.purchaseDetail.create_time_text), 1),
          _createVNode("div", _hoisted_43, [
            _hoisted_44,
            _createVNode("div", _hoisted_45, _toDisplayString(_ctx.purchaseDetail.store_name) + "(" + _toDisplayString(_ctx.purchaseDetail.purchase_type==3?'采购退货单':'采购单') + ") ", 1)
          ]),
          _createVNode("div", _hoisted_46, [
            _createVNode("div", _hoisted_47, " 单据编号：" + _toDisplayString(_ctx.purchaseDetail.purchaes_number), 1),
            _createVNode("table", _hoisted_48, [
              _hoisted_49,
              _createVNode("tbody", null, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.purchaseDetail.data, (item, index) => {
                  return (_openBlock(), _createBlock("tr", { key: index }, [
                    _createVNode("th", null, _toDisplayString(index+1), 1),
                    _createVNode("th", null, _toDisplayString(item.name), 1),
                    _createVNode("th", null, _toDisplayString(item.specification), 1),
                    _createVNode("th", null, _toDisplayString(item.encoding), 1),
                    _createVNode("th", null, _toDisplayString(item.mountings_type_p_name), 1),
                    _createVNode("th", null, _toDisplayString(item.mountings_brand_name), 1),
                    _createVNode("th", null, _toDisplayString(item.mountings_unit_name), 1),
                    (item.purchase_type != 3)
                      ? (_openBlock(), _createBlock("th", _hoisted_50, _toDisplayString(item.member), 1))
                      : (_openBlock(), _createBlock("th", _hoisted_51, _toDisplayString(item.return_number), 1)),
                    (item.purchase_type != 3)
                      ? (_openBlock(), _createBlock("th", _hoisted_52, _toDisplayString(item.member), 1))
                      : (_openBlock(), _createBlock("th", _hoisted_53, _toDisplayString(item.return_number), 1)),
                    _createVNode("th", null, _toDisplayString(item?.quoted_price || 0), 1),
                    _createVNode("th", null, _toDisplayString(item?.cost_price || 0), 1)
                  ]))
                }), 128)),
                _createVNode("tr", null, [
                  _hoisted_54,
                  _createVNode("th", null, _toDisplayString(_ctx.purchaseDetail.number), 1),
                  _createVNode("th", null, _toDisplayString(_ctx.purchaseDetail?.stock_number || 0), 1),
                  _createVNode("th", null, _toDisplayString(_ctx.purchaseDetail?.total_price || 0), 1)
                ]),
                _createVNode("tr", null, [
                  _createVNode("th", _hoisted_55, "备注：" + _toDisplayString(_ctx.purchaseDetail.purchase_desc), 1)
                ])
              ])
            ]),
            _createVNode("div", _hoisted_56, [
              _createVNode("div", _hoisted_57, [
                _createVNode("div", _hoisted_58, " 供应商：" + _toDisplayString(_ctx.purchaseDetail.supplier), 1),
                _createVNode("div", _hoisted_59, " 审核人：" + _toDisplayString(_ctx.purchaseDetail.reviewer_text), 1),
                _createVNode("div", _hoisted_60, " 审核状态：" + _toDisplayString(_ctx.purchaseDetail.toexamine), 1)
              ]),
              _hoisted_61
            ]),
            _createVNode("div", _hoisted_62, [
              _createVNode("div", _hoisted_63, " 地址：" + _toDisplayString(_ctx.purchaseDetail.address), 1),
              _createVNode("div", _hoisted_64, " 电话：" + _toDisplayString(_ctx.purchaseDetail.service_phone), 1)
            ])
          ])
        ])
      ]),
      _: 1
    }, 512), [
      [_vShow, _ctx.isPrint]
    ])
  ], 64))
})